import { createSelector } from "reselect";

const getGDC = (state) => state.variantResult && state.variantResult.nih_gdc;

const getGDCVersion = createSelector(getGDC, (gdc) => gdc && gdc[0].version);

const getGDCData = createSelector(getGDC, (gdc) => {
  return gdc && gdc[0];
});

export { getGDCVersion, getGDCData };
